export function animationFrameDebounce<T extends any[]>(
  handler: (...params: T) => void
) {
  let request: number | null = null;
  return (...params: T) => {
    if (request != null) window.cancelAnimationFrame(request);
    request = window.requestAnimationFrame(() => handler(...params));
  };
}
